export var EExternalViewType;
(function (EExternalViewType) {
    EExternalViewType["MobileApp"] = "mobileApp";
    EExternalViewType["Dashboard"] = "dashboard";
})(EExternalViewType || (EExternalViewType = {}));
